import { IAnalyticsService } from "@msteams/bridges-models-ts-analytics";
import { LoggingService } from "@msteams/bridges-services-ts-logging";

export class AnalyticsService<T extends string | number | symbol>
  implements IAnalyticsService<T> {
  /**
   * Logs panel action event to ARIA
   * @param scenario action scenario
   * @param options additional data to be logged with the scenario
   */
  public logPanelActionEvent(scenario: T, options: any): void {
    LoggingService.logWarning(
      `AnalyticsService is not supported in TMP, scenario: ${scenario}, options: ${options}`
    );
  }
}
